<template>
  <div :class="[$style.footer]">
    <div
      class="new_footer"
      :class="[$style.container]"
    >
      <div v-if="synopsisVisible">
        <div :class="[$style.title]">
          {{ $t('home.platformTitle') }}
        </div>
        <Row :class="[$style.link_list]">
          <Col
            v-for="(item, index) in datas"
            :key="index"
            :class="[index > 1 ? $style.pointer_events_none : '']"
            :span="index === 2 ? 12 : 4"
          >
            <a
              v-for="(child_item, child_index) in item"
              :key="'1-' + child_index"
              :class="[$style.footer_link]"
              href="javscript:;"
              :style="{ width: child_item.width ? child_item.width : '100%' }"
              @click="fn_href(child_item)"
            >
              {{ $t(child_item.title) }}
            </a>
          </Col>
        </Row>
        <div :class="[$style.qrd_div]">
          <div :class="[$style.qrd_item]">
            <div>{{ $t('home.more') }}</div>
            <img
              :class="[$style.qrd_img]"
              src="https://image.kilimall.com/seller/qrd_gzh.jpg"
              width="100"
            >
          </div>
        </div>
      </div>
      <!-- <div :class="[$style.border_div]" /> -->
      <!-- <div :class="[$style.copyright_div]">
        <div>{{ $t('home.copyright') }}</div>
        <div>
          <a
            :class="[$style.footer_link, $style.copyright_link]"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
          >
            {{ $t('home.copyrightCode') }}
          </a>
        </div>
        <div :class="[$style.badge_box]">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43019002001557"
            :class="[$style.badge]"
          >
            <img src="@/assets/img/new_home/beiAnIcon.png">
            <p :class="[$style.filing_code]">湘公网安备 43019002001557号</p>
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ApiConfig from '@/server-config/domain.config'

export default {
  props: {
    // 简介部分显示
    synopsisVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      yearTime: new Date().getFullYear(),
      datas: [
        [
          {
            title: 'home.Kenya',
            href: 'https://www.kilimall.co.ke'
          }
        ],
        [
          {
            title: 'home.sellerCenter',
            href: 'https://www.kilimall.co.ke/index.php?act=seller_login&op=show_login'
          },
          {
            title: 'home.helpCenter',
            href: `${ApiConfig.WAP_URL}/help-center/home?s_id=1002&bs_type=4&c_id=1067`
          },
          {
            title: 'home.joinUs',
            href: 'https://seller.kilimall.ke/create-seller-account/entry'
          },
          {
            title: 'home.trade',
            href: 'http://caetexpo.org.cn',
            width: '300px'
          }
        ],
        [
          {
            title: 'home.website',
            href: 'javscript:void(0)'
          },
          {
            title: 'home.phone',
            href: 'avscript:void(0)'
          },
          {
            title: 'home.email',
            href: 'avscript:void(0)'
          }
        ]
      ]
    }
  },
  methods: {
    fn_href(val) {
      window.open(val.href)
    }
  }
}
</script>

<style lang="less" scoped>
.new_footer_padding {
  display: block;
  width: 100%;
  height: 200px;
  background-color: white;
}

@media (min-width: 768px) {
  .new_footer {
    display: block;
  }
  .new_footer_padding {
    display: none;
  }
}
/deep/ #modal-3 {
  .modal-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    .modal-content {
      width: 600px;
    }
    .modal-footer {
      display: none;
    }
  }
}
</style>

<style module>
.footer {
  background-color: #464443;
}
.container {
  margin: 0 auto;
  max-width: 1200px;
  width: 90%;
  position: relative;
  display: none;
}
.qrd_div {
  position: absolute;
  top: 200px;
  right: 0px;
  color: white;
  font-size: 0.13rem;
  font-weight: 500;
  text-align: center;
}
.qrd_img {
  margin-top: 5px;
  width: 90px;
  height: 90px;
}
.qrd_item {
  margin-bottom: 20px;
}
.title {
  font-weight: 600;
  font-size: 25.6px;
  color: white;
  padding-top: 200px;
  margin-bottom: 40px;
}
.footer_link {
  color: white;
  font-size: 12.8px;
  font-weight: 400;
  margin: 16px 0;
  display: block;
}
.footer_link:hover {
  color: white;
}
.link_list {
  width: 70%;
}
.border_div {
  width: 100%;
  height: 1px;
  background-color: #979797;
  opacity: 0.9;
  margin-top: 50px;
}
.copyright_div {
  text-align: center;
  color: white;
  font-size: 12px;
  padding: 50px 0;
}
.copyright_link {
  display: inline-block;
  margin: 0;
}
.pointer_events_none {
  pointer-events: none;
}
.badge_box {
  width: 300px;
  margin: 0 auto;
  padding: 10px 0;
}
.badge {
  display: inline-block;
  text-decoration: none;
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: center;
}

.filing_code {
  height: 20px;
  line-height: 20px;
  margin: 0px 0px 0px 5px;
  color: #939393;
}
</style>
